__turbopack_context__.v({
  "animatedDialog": "styles-module__eTnzua__animatedDialog",
  "fadeIn": "styles-module__eTnzua__fadeIn",
  "fadeOut": "styles-module__eTnzua__fadeOut",
  "scaleDown": "styles-module__eTnzua__scaleDown",
  "scaleUp": "styles-module__eTnzua__scaleUp",
});
